import { type ImagePropsType } from '@nextgen-web-framework/all';
import { GridviewImagePropType } from '../../../components/GridViewImageGallery/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
import { ComponentType } from '../../registries/types/propTypes';

const transformGridViewImageGallery = (props: CMSTransformerDataType): GridviewImagePropType => {
  const cmsImageGalleryData = Array.isArray(props?.grid_view_image_gallery)
    ? props.grid_view_image_gallery[0]
    : props?.grid_view_image_gallery;

  const { images = [], grid_view_layout } = cmsImageGalleryData || {};

  // Map CMS image data to ImagePropsType
  const mapImagesToImageProps = (cmsImageData: CMSTransformerDataType[]): ImagePropsType[] =>
    cmsImageData.map((imageItem: CMSTransformerDataType) => {
      const { url, target, image } = imageItem;
      return {
        src: image?.url || '',
        alt: image?.title || '',
        ctaConfig: url
          ? {
              href: url,
              target: target,
            }
          : undefined,
      };
    });

  const payload: GridviewImagePropType = {
    componentType: ComponentType.grid_view_image_gallery,
    images: mapImagesToImageProps(images),
    imagesPerRow: grid_view_layout || 1,
  };

  return payload;
};

export default transformGridViewImageGallery;
